<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="5">

          <b-form-group
            description="How long photo shall wait before transitioning?"
          >
            <label>Interval (sec):</label>
            <b-form-spinbutton
              id="match-size"
              v-model="settingsUser.interval"
              :min="intervalMin"
              :max="intervalMax"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group>
            <toggles-form
              :data-array="toggles"
              @toggles-change="handleToggleChange"
            />
          </b-form-group>
        </b-col>
        <b-col cols="5">
          <h3>Add/View Photos</h3>
          <b-form-group
            :description="
              `Click menu to see your current ${userDataPhotos.length} photos`
            "
          >
            <items-sidebar-settings
              :items="userDataPhotos"
              :assets-url-home="assetsURLHome"
            />
          </b-form-group>
          <b-form-group
            description="Choose from different themes for the card photos."
          >
            <item-add-image
              :modal-id="modalImageAddId"
              modal-title="Add Photo & Info"
              btn-title="Process Your Memory"
              name="title"
              @selected-items="handleImageItems"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
import ItemStore from "@/components/blockResources/_components/itemStore";
import ItemAddImage from "@/components/blockResources/_components/itemAddImage";
import ItemsSidebarSettings from "@/components/blockResources/_components/itemsSideBar";
import DefaultPlayList from "@/components/blockResources/resourcePlayList/assets/json/defaultPlayList.json";
export default {
  name: "Settings_PhotoAlbum",
  components: {
    ItemStore,
    ItemAddImage,
    ItemsSidebarSettings
  },
  mixins: [ResourceBlockSettings],
  computed: {
    ...mapGetters({
      apps: "user/apps",
      userData: "user/appsData"
    }),
    /* DATA */
    userDataPhotos() {
      return this.userData &&
        this.userData &&
        this.userData[`app_${this.resource.toolId}`] &&
        this.userData[`app_${this.resource.toolId}`].photos
        ? this.userData[`app_${this.resource.toolId}`].photos
        : DefaultPlayList;
    }
  },
  methods: {
    getListTools() {
      this.$store.dispatch("tools/getListTools").then(resources => {
        console.log(resources);
      });
    },
    handleImageItems(photos) {
      console.log(`These photos selected:${photos}`);
      let photoItems = {
        photos: photos
      };

      let notif = {
        //create message
        title: `${photos.length} Memories Added`,
        description: "Congrats you have updated your family playlist",
        variant: "success"
      };
      const payload = {
        userData: photoItems,
        notif: notif,
        key: "photos"
      };
      this.handleUpdateUserData(payload);
    },
    handleShowPlayListClick() {
      //inside of sidebar?
      this.sidebarModel = false;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    }
  },
  data() {
    return {
      settingsUser: {
        interval:
          this.settings && this.settings.user && this.settings.user.interval
            ? this.settings.user.interval
            : 1,
        transition:
          this.settings && this.settings.user && this.settings.user.transition
            ? this.settings.user.transition
            : "fade",
        _isRepeat:
          this.settings &&
          this.settings.user &&
          this.settings.user._isRepeat !== undefined
            ? this.settings.user._isRepeat
            : true,
        _isShuffle:
          this.settings &&
          this.settings.user &&
          this.settings.user._isShuffle !== undefined
            ? this.settings.user._isShuffle
            : false,
        _hideBottomBar:
          this.settings &&
          this.settings.user &&
          this.settings.user._hideBottomBar !== undefined
            ? this.settings.user._hideBottomBar
            : false,
        _autoPlayPhotoAudio:
          this.settings &&
          this.settings.user &&
          this.settings.user._autoPlayPhotoAudio !== undefined
            ? this.settings.user._autoPlayPhotoAudio
            : true,
        _autoPlayCreatedByAudio:
          this.settings &&
          this.settings.user &&
          this.settings.user._autoPlayCreatedByAudio !== undefined
            ? this.settings.user._autoPlayCreatedByAudio
            : true
      },
      assetsURLHome: "",
      sidebarId: "settings-sidebar",
      sidebarModel: false,
      modalImageAddId: "photoadd",
      intervalMin: 2,
      intervalMax: 100,
      toggles: [
        {
          name: "Hide the bottom menu bar",
          description: "Hide the bottom bar for more presentation space.",
          property: "_hideBottomBar",
          type: "btns",
          text: "Hide the bottom bar for more presentation space.",
          isAvail: true,
          value: false
        },
        {
          name: "Auto-play photo audio",
          description:
            "Automatically plays the audio recorded for photo on transition",
          property: "_autoPlayPhotoAudio",
          type: "btns",
          text: "Automatically plays audio",
          isAvail: true,
          value: true
        },
        {
          name: "Family Audio",
          description:
            "Plays the audio for the family member who added the photo",
          property: "_autoPlayCreatedByAudio",
          type: "btns",
          text:
            "Automatically the audio for the family member who added the photo",
          isAvail: true,
          value: true
        },
        {
          name: "Repeat",
          description: "Keep the memories playing endlessly.",
          property: "_isRepeat",
          type: "btns",
          text: "Keep the memories playing endlessly.",
          isAvail: true,
          value: false
        },
        {
          name: "Shuffle",
          description: "Mix up your photos",
          property: "_isShuffle",
          type: "btns",
          text: "Enable shuffle mode to mix up your photos",
          isAvail: true,
          value: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
